import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfAltaTransferencia = ({ title, list, theme }) => {
	const componentRef = useRef();
	const textIcon = (theme === 'dark' ? '_dark' : '');

	const handlePrint = useReactToPrint({
		documentTitle: 'Relatório Monitoramento Alta Transferência',
		content: () => componentRef.current,
	});

	return (
		<>
			<button className={'buttonIcon ' + theme}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" onClick={handlePrint} /></button>
			<div style={{ display: 'none' }}>
				<div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
					<div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
						<div className="inforow right">
							<h3 style={{ fontSize: '20px' }}>{title}</h3 >
						</div>
						<div className="inforow left">
							<img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
							{
								BACKEND_URL.includes('gruposanta') ? (
									<img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
								) : null
							}
						</div>
					</div>
					<div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
						<div className='inforow right'>
							<div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes </div>
						</div>
						<div className='inforow left'>
							<div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
						</div>
					</div>
					<div className='tablePDF'>
						<table>
							<thead>
								<tr>
									<th>Status</th>
									<th>Paciente</th>
									<th>Leito Anterior</th>
									<th>Leito</th>
									<th>Tempo</th>
								</tr>
							</thead>
							<tbody>
								{list
									.sort((a, b) => {
										// ordenação por leito anterior, alta, alta médica e ultima movimentação
										if (a.LEITOANTERIOR !== null && b.LEITOANTERIOR !== null) {
											return a.LEITOANTERIOR - b.LEITOANTERIOR;
										} else if (a.LEITOANTERIOR !== null) {
											return -1; // a comes first if b.LEITOANTERIOR is null
										} else if (b.LEITOANTERIOR !== null) {
											return 1; // b comes first if a.LEITOANTERIOR is null
										} else if (a.ALTA !== null && b.ALTA !== null) {
											return a.ALTA - b.ALTA;
										} else if (a.ALTA !== null) {
											return -1; // a comes first if b.ALTA is null
										} else if (b.ALTA !== null) {
											return 1; // b comes first if a.ALTA is null
										} else if (a.ALTAMEDICA !== null && b.ALTAMEDICA !== null) {
											return a.ALTAMEDICA - b.ALTAMEDICA;
										} else if (a.ALTAMEDICA !== null) {
											return -1; // a comes first if b.ALTAMEDICA is null
										} else if (b.ALTAMEDICA !== null) {
											return 1; // b comes first if a.ALTAMEDICA is null
										} else {
											return a.ULTIMAMOV - b.ULTIMAMOV;
										}
									})
									.map((data) => {
										let status = "-";
										let color = '';
										let statusClass = "ready";
										let tdClassFarm = "";
										let spanClassFarm = "";
										let name = data.NOMEPACIENTE;
										if (BACKEND_URL.includes('gruposanta')) {
											name = data.NOMEPACIENTE.split(' ').slice(-1).join(' ') + ', ' + data.NOMEPACIENTE.split(' ')[0].slice(0, 1);
										}

										spanClassFarm = "success-circle";
										status = "Transferência";
										if (data.ALTA) {
											status = 'Alta Hospitalar';
											statusClass = "waiting";
										} else {
											if (data.ALTAMEDICA) {
												status = 'Alta Médica';
												statusClass = "waiting";
											}

										}

										if (data.MINUTOS < 30 && data.MINUTOS >= 0) {
											color = 'red';
											tdClassFarm = "attention";
											spanClassFarm = "attention-circle";
										} else {
											spanClassFarm = "success-circle";
										}

										let time = data.MINUTOS;
										if (data.MINUTOS !== 0) {
											var hours = (data.MINUTOS / 60);
											if (hours < 0) {
												hours = hours * -1;
											}
											var rhours = Math.floor(hours);

											var minutes = (hours - rhours) * 60;
											var rminutes = Math.round(minutes);
											time = rhours + " hs " + rminutes + " mins";
										} else {
											time = time + ' mins';
										}
										if (data.MINUTOS < 0) {
											time = 'em ' + time;
											spanClassFarm = "success-circle";
										}

										return (
											<tr key={(data.CODIGOATENDIMENTO  + data.ULTIMAMOV ?? '-' + data.ALTAMEDICA?? '-')} className={statusClass}>
												<td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='alert-content'> <div className="alert-label" /> <b>{status}</b></td>
												<td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{name}</b>  ({data.CODIGOATENDIMENTO})</td>
												<td style={{ color: color }} align="left"><b>{data.LEITOANTERIOR}</b></td>
												<td style={{ color: color }} align="left"><b>{data.LEITO}</b></td>
												<td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
											</tr>
										)
									})
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	);
};

export default PdfAltaTransferencia;